import BpkBreakpoint, {
  BREAKPOINTS,
} from '@skyscanner/backpack-web/bpk-component-breakpoint';

import { ContentSection } from '../../PageContent/MainContent';

import ExpandableReviewsCustomizeMobile from './ExpandableReviewsCustomizeMobile';
import ReviewsCustomizeDesktop from './ReviewsCustomizeDesktop';

import type { HotelReviewSummary } from '@shared/types/hotel-content';
import type { Nullable } from '@shared/types/utils';

import STYLES from './ReviewsCustomizeSection.module.scss';

import {
  useHotelReviewsContext,
  useReviews,
} from '@hotels-hotel-detail/data-access/hooks/useHotelReviewsContext';
import CenteredSpinner from '@shared/ui/components/CenteredSpinner';

type Props = {
  reviewSummary: Nullable<HotelReviewSummary>;
};

const ReviewsCustomizeSection = ({ reviewSummary }: Props) => {
  const { isLoading } = useHotelReviewsContext();

  const reviews = useReviews();

  if (!isLoading && reviews.length === 0) {
    return null;
  }

  if (isLoading && reviews.length === 0) {
    return (
      <CenteredSpinner className={STYLES.ReviewsCustomizeSection__spinner} />
    );
  }

  return (
    <ContentSection className={STYLES.ReviewsCustomizeSection__withoutMargin}>
      <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
        {(isMobile: boolean) =>
          isMobile ? (
            <ExpandableReviewsCustomizeMobile reviewSummary={reviewSummary} />
          ) : (
            <ReviewsCustomizeDesktop />
          )
        }
      </BpkBreakpoint>
    </ContentSection>
  );
};

export default ReviewsCustomizeSection;
